<template>
  <aside :class="['right-sidebar', showSidebar ? 'show' : '']">
    <div class="sidebar-content">
      <div class="sb-top">
        <div class="sac__font-32 semi-bold">
          All Filters
        </div>
        <button
          type="button"
          @click="showSidebar = false"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="img-size-12"
          >
        </button>
      </div>
      <div class="sb-body">
        <div
          v-for="option in filters"
          :key="option.key"
        >
          <fragment
            v-if="option.showSearch"
          >
            <div class="sac__font-14 semi-bold">
              {{ option.label }}
            </div>
            <SearchOption
              class="margin-top-8"
              :item="option"
              :select="updateFilter"
            />
          </fragment>
          <div v-else>
            <div class="sac__font-14 semi-bold">
              <div v-if="option.key === 'checkBox'">
                <div class="flex-row align-center">
                  <div class="margin-right-8">
                    {{ option.label }}
                  </div>
                  <SACCheckbox
                    :checked="option.activeOption.value"
                    :change="() => updateFilter({ value: !option.activeOption.value }, option.key)"
                  />
                </div>
              </div>
              <div v-else>
                {{ option.label }}
              </div>
            </div>
            <div v-if="option.key === 'visitType' || option.key === 'serviceCategory'">
              <div class="option-container">
                <SACSelect
                  :options="option.options"
                  :value="option.activeOption.value"
                  :change="(selected) => updateFilter({ label: selected, value: selected }, option.key)"
                  :backgroundColor="'#f5f7fa'"
                  :width="'400px'"
                  :selectClass="'select-option-active'"
                />
              </div>
            </div>
            <div v-else class="option-container">
              <div
                v-for="(sub, idx) in option.options"
                :key="idx"
                @click="updateFilter(sub, option.key)"
                @keydown="updateFilter(sub, option.key)"
              >
                <button
                  type="button"
                  :class="[
                    sub.showIcon ? 'select-button-2' : 'select-button',
                    isOptionActive(option.activeOption, sub, option.multiple) ? 'active' : '',
                  ]"
                >
                  <img
                    v-if="sub.showIcon"
                    :alt="idx"
                    :src="
                      getLeadImage(
                        sub.value,
                        isOptionActive(option.activeOption, sub, option.multiple),
                      )
                    "
                    class="img-size-24"
                  >
                  <span>{{ sub.label }}</span>
                </button>
              </div>
            </div>
            <div v-if="option.key === 'dateCreated' && option.activeOption.value === 'custom'">
              <div class="option-container">
                <CustomDateRangeFilter :type="'all-filters'" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showSidebar"
          class="sb-action"
        >
          <div class="sb-column">
            <button
              type="button"
              class="img-circle"
              @click="resetFilters"
            >
              <img
                src="@shared/assets/img/general/trash.png"
                alt="x"
                class="img-size-24"
              >
            </button>
            <div class="sac__font-12 semi-bold">
              Clear
            </div>
          </div>
          <div class="sb-column">
            <button
              type="button"
              class="img-circle"
              @click="applyFilters"
            >
              <img
                src="@shared/assets/img/general/check-black.png"
                alt="x"
                class="img-size-14"
              >
            </button>
            <div class="sac__font-12 semi-bold">
              Apply
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import SACSelect from '@shared/components/sac/SACSelect.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import CustomDateRangeFilter from './CustomDateRangeFilter.vue';
import SearchOption from './SearchOption.vue';

export default {
  name: 'AllServiceFilterOptions',
  components: {
    SearchOption, SACSelect, CustomDateRangeFilter, SACCheckbox,
  },
  mixins: [serviceMixin],
  props: {
    loadData: Function,
  },
  data() {
    return {
      compFilters: [],
    };
  },
  computed: {
    filters() {
      const customSortByOptions = {
        scheduled: [
          { label: 'Unit Age', value: 'age' },
          { label: 'Service Type', value: 'serviceType' },
          { label: 'Date Created', value: 'dateCreated' },
        ],
      };
      return this.compFilters
        .filter((filter) => {
          const { key } = filter;
          if (!this.isSmacAdmin && key === 'checkBox') {
            return false;
          }
          if (this.activeTab === 'pending') {
            return ['sortBy', 'unitAge', 'distance', 'lastOccurrence', 'visitType', 'serviceCategory', 'statusPendingTab', 'leadType', 'checkBox'].includes(key);
          }
          if (this.activeTab === 'scheduled') {
            return ['sortBy', 'unitAge', 'distance', 'serviceCategory', 'visitType', 'dateCreated', 'techs'].includes(key);
          }
          if (this.activeTab === 'closed') {
            return ['sortBy', 'statusClosedTab', 'unitAge', 'distance', 'dateCreated', 'visitType', 'serviceCategory', 'leadType', 'techs'].includes(key);
          }
          if (this.activeTab === 'snoozed') {
            return ['sortBy', 'unitAge'].includes(key);
          }
          if (this.activeTab === 'incomplete') {
            return ['sortBy', 'unitAge'].includes(key);
          }
          return true;
        })
        .map((filter) => {
          if (filter.key === 'sortBy') {
            return {
              ...filter,
              options: customSortByOptions[this.activeTab] || filter.options,
            };
          }
          return filter;
        });
    },
    showSidebar: {
      get() {
        return this.$store.state.service.showRightSidebar;
      },
      set(value) {
        this.$store.dispatch('changeServiceValues', [{
          field: 'showRightSidebar',
          value,
        }]);
      },
    },
  },
  watch: {
    serviceFilters: {
      handler(newVal, oldVal) {
        this.compFilters = structuredClone(newVal);
      },
      deep: true,
    },
    show(show) {
      this.showSidebar = show;
      if (show) {
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      } else {
        document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      }
    },
  },
  mounted() {
    this.compFilters = structuredClone(this.serviceFilters);
  },
  methods: {
    getLeadImage(type, active) {
      if (active) {
        return require(`@shared/assets/img/leads/${type}.png`);
      }
      return require(`@shared/assets/img/leads/${type}-black.png`);
    },
    updateFilter(option, key) {
      const newFilters = this.compFilters.map((fo) => {
        if (fo.key === key) {
          if (key === 'leadType') {
            let activeOptions = fo.activeOption;
            const optionExist = activeOptions.find((ao) => ao.value === option.value);
            if (optionExist) {
              activeOptions = activeOptions.filter((ao) => ao.value !== option.value);
            } else {
              activeOptions = [...activeOptions, option];
            }
            fo.active = true;
            fo.activeOption = [...activeOptions];
          } else {
            fo.active = true;
            fo.activeOption = option;
          }
        }
        return fo;
      });
      this.compFilters = [...newFilters];
    },
    async resetFilters() {
      await this.$store.dispatch('clearServiceFilters', {
        key: 'all',
      });
      await this.$store.dispatch('getServiceSummary');
      await this.loadData();
      this.showSidebar = false;
    },
    applyFilters() {
      this.$store.dispatch('changeServiceValues', [{
        field: 'serviceFilters',
        value: this.compFilters,
      }]);
      this.loadData();
      this.$store.dispatch('getServiceSummary');
      this.showSidebar = false;
    },
    isOptionActive(activeOption, option, multiple) {
      if (multiple) {
        const optionExist = activeOption.find((ao) => ao.value === option.value);
        return !!optionExist;
      }
      return activeOption.value === option.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.right-sidebar {
  display: flex;
  flex-direction: column;
  background-color: $WHITE;
  width: 0;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  transition: 0.2s ease-out;
  z-index: 999;
  justify-content: space-between;
  &.show {
    width: 450px;
  }
  .select-option-active {
    background-color: $NBLUE110;
    color: $WHITE;
  }
  .sidebar-content {
    overflow: hidden;
    .sb-top {
      padding: 1.5rem;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
    }
    .sb-body {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 24px;
      height: 75vh;
      padding: 1.5rem;
      overflow: auto;
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .option-container {
        display: grid;
        margin-top: 8px;
        grid-template-columns: repeat(3, 1fr);
      }
    }
    .sb-action {
      display: grid;
      grid-auto-flow: column;
      justify-content: center;
      align-items: center;
      gap: 34px;
      position: absolute;
      height: 104px;
      width: 100%;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.9);
      border-top: 1px solid $N5;
      .sb-column {
        display: grid;
        justify-items: center;
        cursor: pointer;
        .img-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: grid;
          align-items: center;
          justify-content: center;
          background-color: $N5;
        }
      }
    }
  }
}
</style>
